import React, { Suspense, lazy } from "react";
import {
  ActionIcon,
  Group,
  Paper,
  PaperProps,
  Text,
  useMantineColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { IconDotsVertical } from "@tabler/icons-react";

import Surface from "../Surface/Surface";

const Chart = lazy(() => import("react-apexcharts"));

type RevenueChartProps = PaperProps;

const RevenueChart = ({ ...others }: RevenueChartProps) => {
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();

  const series = [
    {
      name: "series1",
      data: [31, 40, 28, 51, 42, 109, 100],
    },
    {
      name: "series2",
      data: [11, 32, 45, 32, 34, 52, 41],
    },
  ];

  const options: any = {
    chart: {
      height: 350,
      type: "area",
      fontFamily: "Open Sans, sans-serif",
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      type: "datetime",
      categories: [
        "2018-09-19T00:00:00.000Z",
        "2018-09-19T01:30:00.000Z",
        "2018-09-19T02:30:00.000Z",
        "2018-09-19T03:30:00.000Z",
        "2018-09-19T04:30:00.000Z",
        "2018-09-19T05:30:00.000Z",
        "2018-09-19T06:30:00.000Z",
      ],
      labels: {
        style: {
          colors: colorScheme === "dark" ? theme.white : theme.black,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: colorScheme === "dark" ? theme.white : theme.black,
        },
      },
    },
    tooltip: {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    },
    colors: [
      theme.colors[theme.primaryColor][5],
      theme.colors[theme.primaryColor][2],
    ],
    legend: {
      labels: {
        colors: [colorScheme === "dark" ? theme.white : theme.black],
      },
    },
  };

  return (
    <Surface
      component={Paper}
      {...others}
    >
      <Group
        justify='space-between'
        mb='md'
      >
        <Text
          size='lg'
          fw={600}
        >
          Total revenue
        </Text>
        <ActionIcon variant='subtle'>
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Group>
      {/*@ts-ignore*/}
      <Chart
          options={options}
          series={series}
          type='area'
          height={350}
          width={"100%"}
        />
    </Surface>
  );
};

export default RevenueChart;
